import { useEffect } from "react";

// SEO ligero para SPA: fija título, meta description y canonical por página.
export default function useSeo({ title, description, path = "" }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://espanaeficiente.es/${path}`.replace(/\/$/, path ? "" : "/"));
  }, [title, description, path]);
}
